<template>
<div class="greybg" :style="{minHeight: contentHeight}">
  <div class="wrap">
    <img class='logo'  src="@/assets/images/background.png" />
    <div class='top-msg' >会员ID：{{memberID}}</div>
    <div class='mid-msg' >微信扫一扫，使用小程序</div>
    <div class='bottom-msg-refid' v-if="myRefMemberId">
      我的推荐人：{{myRefMemberId}}
      <!-- <div>我的推荐人：</div>
      <div>{{myRefMemberId}}</div> -->
    </div>

    <img class='miniapp-code' :src="refMemberCode" />
    <div class='btn-promote' @click="myPromoters">我推广的人：{{numberPromoted}}人</div>
    <div class='forward-fellow' @click="shareother()" v-if="$platform && $platform === 'miniProgram'">转发给小伙伴</div>  
  </div>
</div>
</template>
<script>
export default {
    name: '',
    data () {
        return {
          memberID: localStorage.getItem(this.$env+"memberId"),
          refMemberCode: "",
          myRefMemberId: "", // 我的推荐人ID
          numberPromoted:0
        }
    },
    mounted(){
      this.doGetPromotionCode();
      this.getMyPromotionRefMemberId();
      let initTime = this.initTime
        this.$service.getStatisCommon("evn_dom_finish",{initTime:initTime})
    },
    created(){
        window.addEventListener('resize', this.getHeight);
        this.getHeight()
        this.sendStatics('event_open_page',{currentUrl:34})
    },
    methods: {
      getHeight(){
        this.contentHeight = document.documentElement.clientHeight + "px";
      },
      
      myPromoters(){
        this.$service.getStatisCommon("evn_refer_myreferer",{});
        this.$router.push({path:'/myPromoters'})
        this.$service.getStatisCommon("evn_close_page",{});
      },
      async doGetPromotionCode(){
        let memberId=localStorage.getItem(this.$env+"memberId")
        let data = await this.$service.getMyPromotionCode(memberId);
        if(data.status==200){
            this.refMemberCode=data.result;
        }
      },
      async getMyPromotionRefMemberId(){
        let memberId=localStorage.getItem(this.$env+"memberId")
        let data = await this.$service.getMyPromotionRefMemberId(memberId);
        if(data.status==200){
            this.myRefMemberId=data.result.promoterId || "13923423432";
            this.numberPromoted=data.result.promotedCount;
        }
        let initTime = this.initTime
          this.$service.getStatisCommon("evn_open_page",{initTime: initTime});
      },
      shareother(){
        this.$service.getStatisCommon("evn_refer_referto",{});
        this.sendStatics('event_transmit_partner_click',{currentUrl:34,module:86})
        let path = 'pages/member/member'
        this.$wx.miniProgram.navigateTo({
          url: `../share/share?path=${path}`
        })
      }
      
    }
}
</script>
<style scoped>
.wrap{
  position: relative;
}
.logo {
  width: 9.1733rem;
  height: 11.4133rem;
  align-self: center;
  position: absolute;
  top: 0.6133rem;
  left: 0.4667rem;
}

.message {
  align-self: center;
  margin-bottom: 0.4rem;
  font-size: 0.4533rem;
  color: rgb(154, 156, 155);
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}

.top-msg {
  position: absolute;
  top: 2.4267rem;
  left: 2.5333rem;
  font-family: PingFang-SC-Medium;
  color: rgb(85, 85, 85);
  font-size: 0.4rem;
}

.mid-msg {
  text-align: center;
  position: absolute;
  top: 9.9333rem;
  width: 100%;
  font-family: PingFang-SC-Medium;
  color: rgb(255, 255, 255);
  left: 50%;
  font-size: 0.4rem;
  transform: translate(-50%, 0);
}



.bottom-msg {
  display: flex;
  position: absolute;
  top: 12.6667rem;
  left:50%; 
  transform: translate(-50%, 0);
  font-family: PingFang-SC-Medium;
  color: rgb(85, 85, 85);
  font-size: 0.4rem;
}

.bottom-msg-refid {
  /* display: flex; */
  position: absolute;
  top: 10.8667rem;
  left:0; 
  /* transform: translate(-50%, 0); */
  font-family: PingFang-SC-Medium;
  color: rgb(85, 85, 85);
  font-size: 0.4rem;
  width:100%;
  text-align: center;
}

.bottom-msg-refid div:first-child{
  width: 2.4rem;
}

.promotionCode {
  position: absolute; 
  top: 3.4267rem; 
  left:2.2rem; 
  width:5.6533rem; 
  height: 5.6533rem;
}

.miniapp-code {
  position: absolute;
  top: 3.9333rem;
  left: 2.6rem;
  width: 4.8rem;
  height: 4.8rem;
}
.btn-promote {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 12.2933rem;
  transform: translate(-50%, 0);
  left: 50%;
  font-family: PingFang-SC-Medium;
  color: rgb(255, 255, 255);
  width: 5.8667rem;
  height: 1.2rem;
  background:url('../../assets/images/button-promote.png') no-repeat;
  background-size: 100% 100%;
  font-size: 0.48rem;
}
.forward-fellow{
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 13.8933rem;
  transform: translate(-50%, 0);
  left: 50%;
  font-family: PingFang-SC-Medium;
  color: rgb(235, 97, 18);
  width: 5.8667rem;
  height: 1.2rem;
  background:url('../../assets/images/button-forwarding.png') no-repeat;
  background-size: 100% 100%;
  font-size: 0.48rem;
}
</style>
